module.exports = __webpack_public_path__ + "img/sopt1.edc326b5.svg";